export default {
  lang: 'Italiano ',
  homeScreen: {
    title: 'ALIMENTA I TUOI SOGNI ',
    stayConnected: 'Rimani connesso:',
    download: 'Scarica ora',
  },
  notification: {
    newAndNow: 'Novità!',
    alert: 'Allerta',
    message: 'Messaggio',
    contest: 'Concorso',
    badge: 'Nuovo Distintivo',
    'content-update': 'Aggiornamento dei Contenuti',
    events: 'Eventi',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vediamo se riusciamo a trovare un profilo esistente per lei nel nostro sistema.',
      homeTitleSub:
        "Inserite l'indirizzo e-mail che utilizzate di solito per accedere ai programmi di formazione.",
      noAccount:
        "Nessun account trovato ({email}), provare con un'altra e-mail o creare un account ora.",
      continueButton: 'Continua',
      success:
        'Il tuo account è stato aggiornato con successo! Verrete reindirizzati a breve alla pagina iniziale.',
      successNewAccount:
        "Per completare la registrazione, riceverete un'e-mail di conferma per verificare il vostro account.",
      loginButton: 'Accesso',
      matchFound:
        'Abbiamo trovato una corrispondenza, inserire la password per continuare.',
      magicLink: "Effettuare l'accesso tramite un link inviato via e-mail:",
      magicLinkButton: 'Richiesta di collegamento magico',
      magicLinkTitle:
        'Riceverete un link diretto al vostro indirizzo e-mail che vi consentirà di accedere immediatamente.',
      otherEmailButton: 'Invia',
      title:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      titleIndustry:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      register: 'Creare un account',
      agent: 'Consulente di viaggio',
      visitor: 'Visitatore del settore',
      step1: 'Passo 1: Tipo di utente',
      step2: 'Fase 2: Creare un account',
      step3: 'Fase 3: Creare il profilo',
      marketingOptIn:
        'Siete sicuri di non essere interessati a rimanere in contatto con il team di travel trade di questo programma?',
      optIn: 'Sì, sono interessato',
      optOut: 'Non interessato',
      step2Sub1: 'Parlaci di te',
      step2Sub2: 'Parlateci della vostra attività',
      privacyHead: 'PREFERENZE DI COMUNICAZIONE',
      privacySub:
        'Selezionate le caselle sottostanti per assicurarvi di ricevere le comunicazioni più importanti dal team del settore viaggi del fornitore (aggiornamenti e annunci sui prodotti, premi, incentivi, FAM, ecc.) e le iniziative di networking e supporto alle vendite del settore viaggi di TravPRO Mobile.',
      privacy:
        'Proteggiamo la vostra privacy e non vendiamo, abusiamo o tradiamo mai la vostra fiducia.',
      store: 'Scaricate facilmente questo programma dal vostro app store:',
      powered: 'ALIMENTATO DA',
      toastMessage: {
        forgotSuccess:
          'Abbiamo inviato per e-mail il link per la reimpostazione della password! Sarete reindirizzati alla pagina di accesso entro 10 secondi.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
        magicLinkMessage: 'Attenda, la stiamo registrando in questo momento.',
        magicLinkError:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkError1:
          "Non è stato possibile trovare un token valido, si prega di effettuare il login o di richiedere un nuovo link magico. Se il problema persiste, contattateci all'indirizzo: info@travpromobile.com.",
        magicLinkError2:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkSuccess:
          "Controllate la vostra e-mail all'indirizzo {email}. C'è un link magico che vi farà accedere.",
        magicLinkErrorWait:
          'Attendere 5 minuti tra le richieste di link magico.',
        emailNotFoundError:
          "L'indirizzo e-mail inserito non è presente nei nostri archivi. Si prega di verificare la presenza di errori ortografici o di creare un account.",
      },
      errors: {
        zipCodeNotFound: 'Codice postale non trovato, riprovare',
        zipCodeOnlyNumbers: 'ZipCode può contenere solo numeri',
        password: 'Inserire una password',
        passwordNotMatching: 'Le password inserite non corrispondono',
        passwordTooShort: 'La password deve essere di almeno 8 caratteri',
        emailExists:
          'Questo indirizzo e-mail esiste già o non è valido. Provare con un altro indirizzo e-mail o accedere al proprio account.',
        fillInAllFields: 'Compilare tutti i campi richiesti',
        fillInEmail: 'Inserite il vostro indirizzo e-mail.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
      },
      fields: {
        forgotSubCopy: 'Avete dimenticato la password e volete cambiarla?',
        forgotSubCopy2:
          "Volete evitare completamente la password? Vi invieremo un'e-mail con un link magico che vi farà accedere automaticamente al programma.",
        city: 'Città',
        companyName: 'Nome della società',
        role: 'Il vostro ruolo',
        description: "Quale descrive meglio l'attività della vostra azienda?",
        country: 'Paese',
        password: 'Password',
        passwordRegister: 'Scegliere la password (minimo 8 caratteri)',
        passwordConfirm: 'Conferma la password',
        firstName: 'Nome (dato)',
        lastName: 'Cognome (Famiglia)',
        agency: "Nome dell'agenzia",
        title: 'Il vostro ruolo (selezionare uno)',
        company: 'Nome della società',
        select: "Selezionare un'opzione qui sotto",
        state: 'Stato',
        province: 'Provincia/Regione/Stato',
        zipCode: 'Codice postale',
        postalCode: 'Codice postale',
        affiliate: 'Qual è il vostro gruppo di appartenenza principale?',
        hostAgency: "L'agenzia ospitante?",
        executive: 'Esecutivo',
        management: 'Gestione',
        marketing: 'Marketing',
        sales: 'Vendite',
        coordinator: 'Coordinatore',
        opt: 'Rimanete in contatto con il team del settore viaggi di questo programma e ricevete gli aggiornamenti.',
        optMarketing:
          'Rimanete in contatto con TravPRO per programmi ed eventi simili.',
        retail: 'Fronte del negozio al dettaglio',
        home: 'Agente a domicilio',
        independent: 'Contraente indipendente',
        host: 'Agenzia ospitante',
        call: 'Call center o agenzia web',
        other: 'Altro',
        describes: "Cosa descrive meglio l'attività sua e della sua agenzia?",
      },
    },
    title:
      'Corso per agente di viaggio e programma di abilitazione alle vendite',
    welcome: {
      headerTop: 'Benvenuto al',
      headerBottom: 'Leggi il manuale di vendite della STAR California. ',
    },
    sellingPoints: [
      'Risorsa di conversione delle vendite giornaliere',
      'Scoperte e presentazioni ad alto impatto',
      'Personalizza la cartella “preferiti“',
      'Online o offline - Sempre e ovunque',
      'Condividi, collegati e converti',
    ],
    emailPrompt:
      'Inserisci il tuo indirizzo email per confermare che sei un agente di viaggio.',
    tAndC: {
      agree: 'Continuando sei d’accordo con la nostra ',
      privacyPolicy: 'politica sulla privacy',
      and: ' e ',
      termsConditions: ' i termini e le condizioni',
    },
    fields: {
      agency: 'Agenzia',
      email: 'Email',
      firstName: 'Nome',
      lastName: 'Cognome',
      agencyName: 'Nome dell‘agenzia',
      stateProvince: 'Stato / Provincia',
      registrationCode: 'Codice Promozionale (Facoltativo)',
      required: 'Richiesto',
      invalidEmail: 'Indirizzo email non valido',
      opt: 'Resta in contatto! Sì, vorrei optare per le comunicazioni da Visit California che mi terranno aggiornato su notizie, eventi, incentivi, FAM e altro!',
      forgot:
        "Avete dimenticato la password? Cliccate sul pulsante qui sotto e vi invieremo un'e-mail per reimpostare la password.",
    },
    forgot: 'Reimpostare la password',
    noAgent: {
      noAgentButton: 'Non sono un consulente',
      title: 'Grazie per il tuo interesse nella STAR California.',
      messageWeb:
        'Il contenuto del sito è esclusivamente per gli agenti di viaggio. \n Per saperne di più sulla STAR California, visita: ',
      messageMobile:
        'Alcuni contenuti di questa app sono esclusivamente per gli agenti di viaggio, ma sentiti libero di sfogliare un’anteprima di ciò che offre questa app premendo su “Continua“.',
      continue: 'Continua',
      visitWebsite: 'Visita il sito internet >',
    },
    newUser: 'Nuovo utente',
    register: 'Registrati',
  },
  welcomeScreen: {
    title:
      'Benvenuto sul manuale di vendite e programma di formazione della STAR California ',
    helloUser: 'Ciao {name}',
    hello: 'Ciao,',
    fromAgency: 'da {agency}',
    notUser: 'No {name}?',
    introOnline:
      'Segui subito il corso online o precarica il contenuto il modo che sia sempre disponibile per l’utilizzo offline!',
    introOffline:
      'Hai già precaricato l’ultima versione. Inizia il corso o la vendita sempre e ovunque!',
    startTraining: 'Inizia il corso',
    downloader: {
      preload: 'Precarica',
      stop: 'Stop',
      init: 'Inizializzazione...',
      lastUpdate: 'Ultimo aggiornamento: ',
    },
  },
  trainingScreens: {
    review: 'Rivedere',
    start: 'Inizio',
    continue: 'Continua',
    welcome:
      "Benvenuto nella nostra sezione Formazione ridisegnata. Completa semplicemente i moduli per guadagnare punti verso il tuo obiettivo finale di diventare un CA STAR d'oro! La barra a destra ti mostrerà esattamente come stai!",
    restart: 'Riavvio',
    durationInMinutes: '{numero} minuti',
    percentageComplete: '{numero}% completato',
    unlock:
      'Sblocca questo capitolo completando il capitolo {number} del corso.',
    unlockSpecialization: 'Sblocca questo capitolo completando Le Basi',
    unlockSubtitle: 'Sblocca più capitoli completando i capitoli del corso.',
    allUnlocked: 'Hai sbloccato tutti i capitoli!',
    certificate: 'Certificato',
    courseComplete: 'Corso completato!',
    chapterComplete: 'Chapter complete!',
    message: '{count} Messaggio della STAR',
    messagePlural: '{count} Messaggi della STAR',
    endReached: 'Hai finito',
    retainEnd:
      'Utilizza la barra superiore per navigare in questo capitolo o fai clic su Indietro per tornare alla panoramica.',
    watchListenRead: 'Guarda, ascolta e leggi di più',
    trouble: 'Sembra che tu abbia dei problemi, vuoi saltare questa domanda?',
    confirm: 'Conferma la tua risposta',
    choose: 'Scegli una risposta',
    chapter: 'Capitolo',
    essential: 'Moduli Essenziali',
    essentialSub:
      'Completa questi moduli per conseguire Lo Stato CA STAR di Bronzo',
    specialization: 'Moduli di specializzazione',
    specializationSub:
      'Completa questi moduli per conseguire Lo Stato CA STAR d’Argento',
    status: 'Stato Attuale',
  },
  nav: {
    home: 'Home',
    train: 'Treno',
    retain: 'Mantenere',
    directory: 'Directory',
    promote: 'Promuovere',
    sell: 'Vendere',
    info: 'Info',
    media: 'Media',
    favorites: 'Preferiti',
    contact: 'Contatto',
    reportCard: 'Certificato',
    accountSettings: 'Impostazioni dell‘account',
    messages: 'Messaggio della STAR',
    search: 'Cerca',
    showcases: 'Vetrine',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Libreria del corso',
    retain: 'Conserva',
    subapps: 'Mini corso per il partner della California',
    maintrainings: 'La Fondazione',
    subtrainings: "L'esperienza",
  },
  pageDescriptions: {
    train: 'Educare, coinvolgere e diventare un esperto.',
    retain:
      "La tua risorsa di riferimento per conservare le tue conoscenze specialistiche e consentire i tuoi sforzi di vendita. Utilizza quest'area per rispondere in modo esperto a una domanda sul prodotto o anche come presentazione di vendita estemporanea, sempre, ovunque e da qualsiasi dispositivo.",
    promote:
      'Facile accesso a collaterali di vendita condivisibili e modo facile di contattarci.',
    sell: 'Tutti i beni multimediali e le garanzie di vendita sono organizzati per un facile accesso e una facile condivisione.',
    favorites: 'Controlla i tuoi contenuti personali preferiti',
    search: 'Guarda tutti i contenuti',
    subapps: 'Scopri di più dai nostri partner',
    maintrainings:
      'Completa questi capitoli essenziali per ottenere il tuo diploma!',
    subtrainings:
      'Guadagnate un distintivo completando ogni esperienza specializzata qui sotto.',
  },
  general: {
    showcase: 'Showcases',
    next: 'Avanti',
    previous: 'Precedente',
    submit: 'Invia',
    back: 'Indietro',
    close: 'Vicino',
    page: 'Pagina',
    search: 'Cerca',
    logIn: 'Accedi',
    logOut: 'Esci',
    viewItem: 'Visualizza',
    imageNotFound: 'Immagine non trovata',
    noResultsFor: 'Nessun risultato per: {query}',
    noFavorites: 'Non hai ancora dei preferiti.',
    noMessages: 'Non hai ancora ricevuto dei messaggi!',
    resultsFor: 'Risultati per: {query}',
    showAll: 'Mostra tutto',
    connectionError: 'Errore di connessione',
    alreadyExists: 'Già esistente',
    pageNotFound: 'Errore 404, pagina non trovata!',
    oops: 'Oh oh...',
    overview: 'Ritorno alla panoramica',
    complete: 'Corso completato!',
    share: 'Condividi',
    destinations: 'Mini corso per il partner della California',
    essentials: 'Elementi essenziali della California',
    trainingLibrary: 'Libreria del corso',
    message: '{count} Messaggio della STAR',
    messagePlural: '{count} Messaggi della STAR',
    badge: 'Distintivo',
  },
  itemTypes: {
    image: 'Immagine',
    brochure: 'Collezione',
    layout: 'Layout',
    web: 'Sito internet',
    pdf: 'PDF',
    carousel: 'Collezione',
  },
  questions: {
    dials: 'Ruota i quadranti per abbinare la risposta',
    fitb: 'Compila gli spazi vuoti',
    flip: 'Modifica il numero per abbinare la risposta',
    multipleChoice: 'Scegli la risposta o le risposte corrette',
    slider: 'Scegli la risposta corretta usando il cursore',
    map: 'Rispondi alla domanda facendo clic sulla giusta posizione sulla mappa',
    dropdown: 'Scegli...',
    true: 'Vero',
    false: 'Falso',
  },
  cookies: {
    consent: 'CONCORDO',
    optout: 'Non partecipazione',
    settings: 'Impostazioni sulla privacy',
    message:
      'Non ci hai detto nulla sulle tue preferenze circa la privacy dei dati! Non è un problema, ma vorremmo offrirti la migliore esperienza possibile nell’utilizzo del manuale di vendite.',
    disabled: 'Sembra che tu abbia disabilitato l’utilizzo dei cookie.',
    use: 'La {appName} necessita dell‘utilizzo dei cookie per offrirti la migliore esperienza possibile.',
    details: 'A cosa servono i cookie?',
    enable: 'Scopri come abilitare i cookie {here}.',
    here: 'qui',
  },
  notLoggedIn: {
    super: 'Non hai effettuato l‘accesso',
    title: 'Devi essere registrato per visualizzare questo contenuto',
    guest: 'Ospite',
  },
  demo: {
    message:
      'Questo sito internet è una demo del prodotto finale. È attualmente in fase di sviluppo e non è un prodotto finito.',
    consent: 'Ho capito',
  },
  share: {
    header: 'Condividi questa risorsa sui tuoi social media preferiti!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Pagina',
  },
  onMobile: {
    header:
      'Sembra che tu stia cercando di accedere all‘app {appName} da un dispositivo mobile',
    body: 'Per scaricare questo programma è sufficiente andare sul tuo app store e cercare {appName} o fare clic su uno dei seguenti pulsanti ',
    benefits: {
      header: 'Ti fornirà:',
      1: 'Portabilità',
      2: 'Nessun bisogno di WiFi, studia dove e quando ti fa più comodo',
      3: 'Strumenti e risorse di vendita a portata di mano',
    },
  },
  sharing: {
    twitter:
      'Prendi in considerazione la California come meta delle tue prossime vancanze…',
    imageEmailSubject:
      'Solo per te dalla STAR California... Idee per le vacanze',
    imageEmailCopy:
      'Prenditi un minuto per rivedere il contenuto delle vacanze della STAR California in allegato e… buon divertimento!',
    videoEmailSubject:
      'Saranno condivise con te delle fantastiche idee per le vacanze della STAR California!',
    videoEmailCopy:
      'Pensavo che ti sarebbe piaciuto questo video sulle vacanze della STAR California Fai clic sul link seguente.  Buon divertimento!',
    infographicEmailSubject:
      'Condividi i tuoi pensieri sulle idee per le vacanze della STAR California...',
    infographicEmailCopy:
      'Ho pensato che potrebbe interessarti, prenditi un minuto per vedere il contenuto in allegato.   A presto!',
    copyURL: 'Copia link',
    copied: 'Copiato',
  },
  newTrainingFlow: {
    tip: 'Ottieni il tuo status completando I moduli entro ogni livello. Sogna da grande e raggiungi lo stato di CA STAR d’Oro completando tutti I moduli',
    essentialModules: 'Moduli Essenziali',
    finishBronze:
      'Completa questi moduli per conseguire Lo Stato CA STAR di Bronzo',
    specializationModules: 'Moduli di specializzazione',
    finishSilver:
      'Completa questi moduli per conseguire Lo Stato CA STAR d’Argento',
    partnerModules: 'Moduli dei Partner',
    finishGold: 'Completa questi moduli per conseguire Lo Stato CA STAR d’Oro',
    currentStatus: 'Stato Attuale',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'fino a quando hai raggiunto la classificazione di {rank}',
    outOf: '{points} XP su',
    pointsToRank:
      '{pointsToLevel}} XP necessario per la classificazione:  ({rank})',
  },
  points: {
    completed: '{completed} / {total} completato',
  },
  new: {
    achievements: 'Raggiungimenti',
  },
  badgeView: {
    title: 'Obiettivi di formazione',
    subtitle:
      'Benvenuti nel vostro cruscotto dei traguardi, dove potrete visualizzare, monitorare e scaricare i vostri badge di diploma e di specializzazione.',
    badgeDisplayTitle: 'Stato di conseguimento metallico',
    badgeAchievement:
      "Hai raggiunto lo stato {rank}! Fate clic sull'icona a destra per visualizzare e condividere il vostro stato.",
    bronze: 'Bronzo',
    silver: 'Argento',
    gold: 'Oro',
    platinum: 'Platino',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Badge di specializzazione',
    partnerBadges: 'Distintivi per i partner',
  },
  badgeDisplay: {
    status: 'Stato di avanzamento della formazione',
  },
  search: {
    pages: 'Pagine',
    resources: 'Risorse',
  },
};
